<template>
	<div>
		<div id="wrap">
			<div>
				<el-button type="primary" @click="handleAdd">添加凭证</el-button>
				<el-button type="primary" @click="upload.open = true"
					>批量导入</el-button
				>
			</div>
			<el-form :inline="true" class="from" ref="formQuery" :model="queryParams">
				<el-form-item label="科目代码/名称">
					<el-select
						v-model="queryParams.subjectId"
						placeholder="请选择科目代码/名称"
					>
						<el-option label="全部" value=""></el-option>
						<el-option-group
							v-for="(group, i) in subjectList"
							:key="i"
							:label="i"
						>
							<el-option
								v-for="item in group"
								:key="item.id"
								:label="item.subjectName"
								:value="item.id"
							>
							</el-option>
						</el-option-group>
					</el-select>
				</el-form-item>
				<el-form-item label="凭证日期">
					<el-date-picker
						v-model="queryParams.time"
						type="daterange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						value-format="yyyy-MM-dd"
						@change="timeChange"
					>
					</el-date-picker>
				</el-form-item>
				<el-form-item label="">
					<el-button type="primary" @click="handleQuery">查询</el-button>
					<el-button type="primary" @click="resetQuery">重置</el-button>
				</el-form-item>
			</el-form>
			<!--    <div style="margin-top:10px;">-->
			<!--        <el-button type="primary" @click="centerDialogVisible = true">添加凭证</el-button>-->
			<!--        <el-button>结转管理费用</el-button>-->
			<!--        <el-button>结转无形资产</el-button>-->
			<!--        <el-button>批量导入</el-button>-->

			<!--    </div>-->

			<!-- 导入 -->
			<el-dialog
				title="批量导入"
				:visible.sync="upload.open"
				center
				width="44%"
			>
				<div class="dialog_content">
					<div class="download" style="margin-top: 20px;line-height: 25px">
						<div>填写需要导入的数据</div>
						<div style="color: #a3adb9">
							请按照数据模板的格式准备导入数据,模板中的表头名称不可更改,表头行不能删除,表格格式不能修改
						</div>
						<div>
							<el-link type="primary" :underline="false" @click="importTemplate"
								>下载模板</el-link
							>
						</div>
					</div>
					<div class="upload" style="margin-top: 20px;line-height: 25px">
						<div>上传填好的表格</div>
						<div style="color: #a3adb9">
							文件后缀名必须为xls或xsx (即Excel格式) ,文件大小不得大于5M
						</div>
						<el-upload
							class="upload-demo"
							ref="upload"
							:limit="1"
							accept=".xlsx, .xls"
							:action="upload.url"
							:disabled="upload.isUploading"
							:auto-upload="false"
							:data="{ whetherHighTech: 2, projectId: projectId }"
							:on-progress="handleFileProgress"
							:on-success="handleFileSuccess"
							:on-exceed="handleFileExceed"
						>
							<el-link type="primary" :underline="false">上传文件</el-link>
						</el-upload>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="upload.open = false">取 消</el-button>
					<el-button type="primary" @click="submitFileForm">保存</el-button>
				</div>
			</el-dialog>

			<el-dialog
				title="凭证列表"
				:visible.sync="centerDialogVisible"
				width="30%"
				center
			>
				<div>
					<el-form
						label-width="120px"
						:model="formData"
						:rules="rules"
						ref="formData"
					>
						<el-form-item v-if="!type" prop="projectId" label="选择项目：">
							<el-select v-model="formData.projectId" placeholder="项目">
								<el-option
									v-for="dict in projectList"
									:key="dict.id"
									:label="dict.projectName"
									:value="dict.id"
									placeholder="请选择"
								>
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="documentDate" label="凭证日期：">
							<el-date-picker
								:editable="false"
								value-format="yyyy-MM-dd"
								:picker-options="pickerOptions"
								v-model="formData.documentDate"
								placeholder="请选择"
							>
							</el-date-picker>
						</el-form-item>
						<el-form-item prop="voucherFont" label="凭证字：">
							<el-radio
								v-for="dict in voucherFont"
								v-model="formData.voucherFont"
								:key="dict.dictCode"
								:label="dict.dictCode"
								>{{ dict.dictName }}</el-radio
							>
						</el-form-item>
						<el-form-item prop="voucherNumber" label="凭证号：">
							<el-input v-model="formData.voucherNumber"></el-input>
						</el-form-item>
						<el-form-item prop="summary" label="摘要：">
							<el-input v-model="formData.summary"></el-input>
						</el-form-item>
						<el-form-item prop="subjectId" label="科目代码/名称：">
							<el-select
								v-model="formData.subjectId"
								placeholder="请选择科目代码/名称"
							>
								<el-option-group
									v-for="(group, i) in subjectList"
									:key="i"
									:label="i"
								>
									<el-option
										v-for="item in group"
										:key="item.id"
										:label="item.subjectName"
										:value="item.id"
									>
									</el-option>
								</el-option-group>
							</el-select>
						</el-form-item>
						<el-form-item prop="voucherAmount" label="凭证金额：">
							<el-input-number
								:controls="false"
								v-model="formData.voucherAmount"
							></el-input-number>
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="centerDialogVisible = false">返回</el-button>
					<el-button type="primary" @click="classSubmitForm">保存</el-button>
				</span>
			</el-dialog>

			<el-table
				class="table"
				:data="datas"
				:header-cell-style="{ background: '#F5F7FA' }"
				v-loading="loading"
				:row-class-name="tableRowClassName"
			>
				<el-table-column
					label="凭证日期"
					prop="documentDate"
					show-overflow-tooltip
				></el-table-column>
				<el-table-column prop="name" label="凭证字">
					<template slot-scope="scope">
						{{ selectDictLabel(voucherFont, scope.row.voucherFont) }}
					</template>
				</el-table-column>
				<el-table-column
					prop="voucherNumber"
					label="凭证号"
					show-overflow-tooltip
				></el-table-column>

				<el-table-column label="科目名称" prop="subjectName"></el-table-column>
				<el-table-column label="金额" prop="voucherAmount"></el-table-column>
				<el-table-column
					label="更新时间"
					prop="updateTime"
					width="200"
				></el-table-column>

				<el-table-column label="操作" width="100" fixed="right">
					<template slot-scope="scope">
						<el-button
							type="text"
							size="small"
							class="green"
							@click="handleUpdate(scope.row.id)"
							>编辑</el-button
						>
						<el-button
							type="text"
							size="small"
							class="red"
							@click="handleDelete(scope.row.id)"
							>删除</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<div class="flex flex-end">
				<el-pagination
					class="pagination"
					background
					v-show="total > 0"
					:total="total"
					:current-page.sync="queryParams.pageNum"
					:page-size.sync="queryParams.pageSize"
					@current-change="getList"
				>
				</el-pagination>
			</div>
		</div>
		<import-tips
			:show="importOpen"
			:data="importData"
			:succeedNumber="importSucceedNumber"
			:errorNumber="importErrorNumber"
			@importOpnes="importOpnes"
		/>
	</div>
</template>

<script>
import importTips from "./importTips.vue";
import {
	importDateDownloadTemplate,
	projectManagementGet,
	voucherQuerySubjects,
	vouchertQuery,
	voucherQueryOne,
	voucherAdd,
	voucherUpdate,
	voucherDelete
} from "../index";
import { getDict } from "@/api/ChinaHigh";

export default {
	components: {
		importTips
	},
	props: {
		projectId: {
			type: String,
			default: ""
		},
		type: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			upload: {
				// 是否显示弹出层
				open: false,
				// 是否禁用上传
				isUploading: false,
				// 上传的地址
				url: this.mainBaseURL + "/voucher/importVouchers"
			},
			importOpen: false,
			importData: [],
			importSucceedNumber: 0,
			importErrorNumber: 0,
			voucherFont: [],
			centerDialogVisible: false,
			queryParams: {
				pageNum: 1,
				pageSize: 10
			},
			datas: [],
			total: 1,
			formData: {},
			rules: {
				documentDate: [
					{ required: true, message: "请选择凭证日期", trigger: "change" }
				],
				voucherFont: [
					{ required: true, message: "请选择凭证字", trigger: "change" }
				],
				voucherNumber: [
					{ required: true, message: "请输入凭证号", trigger: "blur" }
				],
				summary: [{ required: true, message: "请输入摘要", trigger: "blur" }],
				subjectId: [
					{ required: true, message: "请选择科目代码/名称", trigger: "change" }
				],
				voucherAmount: [
					{ required: true, message: "请输入凭证金额", trigger: "blur" }
				]
			},
			amortizationTotal: "",
			projectList: [],
			// 遮罩层
			loading: true,
			//日期限制
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now() - 8.64e6;
				}
			},
			subjectList: []
		};
	},
	created() {
		this.resetQuery();
		this.chushi();
	},
	methods: {
		chushi() {
			getDict({ type: "loan_type" }).then(res => {
				this.voucherFont = res.data;
			});
			voucherQuerySubjects().then(res => {
				this.subjectList = res.data;
			});
		},
		tableRowClassName({ row, rowIndex }) {
			if ((rowIndex + 1) % 2 === 0) {
				return "background:#fff";
			} else {
				return "background:#F5F7FA";
			}
		},
		/** 列表 */
		getList() {
			this.loading = true;
			vouchertQuery(this.queryParams).then(res => {
				if (res.code == "00000") {
					this.datas = res.data.records;
					this.total = res.data.total;
				}
				this.loading = false;
			});
		},
		/** 搜索按钮操作 */
		handleQuery() {
			this.queryParams.pageNum = 1;
			this.queryParams.pageSize = 10;
			this.getList();
		},
		/** 重置按钮操作 */
		resetQuery() {
			this.resetForm("formQuery");
			this.queryParams = {};
			if (this.type) {
				this.queryParams.projectId = this.projectId;
			}
			this.queryParams.beginTime = "";
			this.queryParams.endTime = "";
			this.queryParams.whetherHighTech = 2;
			this.queryParams.importFlag = null;
			this.handleQuery();
		},
		// 表单重置
		reseForm() {
			this.formData = {};
			if (!this.type) {
				projectManagementGet().then(res => {
					this.projectList = res.data;
				});
			} else {
				this.formData.projectId = this.projectId;
			}
			this.resetForm("formData");
		},
		// 新增
		handleAdd() {
			this.reseForm();
			this.centerDialogVisible = true;
		},
		handleUpdate(id) {
			this.reseForm();
			voucherQueryOne(id).then(res => {
				this.formData = res.data;
				this.centerDialogVisible = true;
			});
		},
		classSubmitForm() {
			this.$refs["formData"].validate(valid => {
				if (valid) {
					if (this.formData.id == undefined || this.formData.id == "") {
						voucherAdd(this.formData).then(res => {
							if (res.code === "00000") {
								this.handleQuery();
								this.centerDialogVisible = false;
								this.msgSuccess(res.msg);
							}
						});
					} else {
						voucherUpdate(this.formData).then(res => {
							if (res.code === "00000") {
								this.handleQuery();
								this.centerDialogVisible = false;
								this.msgSuccess(res.msg);
							}
						});
					}
				} else {
					return false;
				}
			});
		},
		handleDelete(id) {
			this.$confirm("是否确认删除?", "警告", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(function() {
					return voucherDelete({ ids: [id] });
				})
				.then(() => {
					this.getList();
					this.msgSuccess("删除成功");
				})
				.catch(function() {});
		},
		// 日期选择
		timeChange(val) {
			if (val != null) {
				this.queryParams.beginTime = val[0];
				this.queryParams.endTime = val[1];
			} else {
				this.queryParams.beginTime = "";
				this.queryParams.endTime = "";
			}
		},
		importTemplate() {
			importDateDownloadTemplate(7).then(res => {
				if (res.code == "00000") {
					window.open(res.data, "_blank");
				}
			});
		},
		handleFileProgress(event, file, fileList) {
			this.upload.isUploading = true;
		},
		handleFileSuccess(response, file, fileList) {
			if (response.code == "00000") {
				this.upload.open = false;
				this.upload.isUploading = false;
				this.$refs.upload.clearFiles();
				this.importOpen = true;
				this.importData = response.data.errorList;
				this.importSucceedNumber = response.data.succeedNumber;
				this.importErrorNumber = response.data.errorNumber;
				this.getList();
			} else {
				this.upload.isUploading = false;
				this.$refs.upload.abort();
				this.$message.error(response.msg);
			}
		},
		submitFileForm() {
			this.$refs.upload.submit();
		},
		handleFileExceed(response) {
			this.$alert("只能上传一个文件");
		},
		importOpnes() {
			this.importOpen = false;
			this.importData = [];
			this.importSucceedNumber = 0;
			this.importErrorNumber = 0;
		}
	}
};
</script>
<style scoped>
.from {
	margin-top: 15px;
}
.item_btn {
	float: right;
}
.item_box .flex > div {
	width: 100%;
	color: #222;
	font-size: 14px;
	line-height: 30px;
}
</style>
